import React from 'react';
import Popup from 'react-popup';

import DriverLifeEvents from './DriverLifeEvents';

Popup.registerPlugin('driverLifeEvents', function plugin(driver) {
  this.create({
    title: `Eventos de Motorista: ${driver.firstName}`,
    className: 'large-popup',
    content: (<DriverLifeEvents driver={driver} />),
  });
});


export default function (driver) {
  Popup.plugins().driverLifeEvents(driver);
}



// WEBPACK FOOTER //
// ./src/Driver/DriverLifeEventsPopup/index.js